import { Alert, Box, Button, Typography } from "@mui/material";
import { IDeleteCandidateError } from "../../../../App/Typings/Candidate";
import { DataType, Table } from "ka-table";

export function DeleteCandidatesModalBody({
  candidatesToDelete,
  failedDeletes,
  responseMessage,
}: {
  candidatesToDelete: string[];
  failedDeletes: IDeleteCandidateError[];
  responseMessage: string;
}) {
  const message = `Are you sure you want to delete ${candidatesToDelete.length} candidate${
    candidatesToDelete.length > 1 ? "s" : ""
  }?`;
  const response = responseMessage ? responseMessage : "Some candidates could not be deleted.";
  return (
    <Box>
      {!failedDeletes || failedDeletes.length === 0 ? (
        <>
          <Typography>{message}</Typography>
          <Alert severity="warning" sx={{ mt: 2 }}>
            This action cannot be undone.
          </Alert>
        </>
      ) : (
        <Box data-test="failed-deletes" sx={{ "& .ka-cell-text": { lineHeight: "1.3" } }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            {response}
          </Alert>
          <Table
            data={failedDeletes}
            rowKeyField="candidateId"
            columns={[
              { key: "candidateId", title: "Candidate ID", dataType: DataType.String },
              { key: "error", title: "Error", dataType: DataType.String },
            ]}
            childComponents={{
              dataRow: {
                elementAttributes: (props) => ({
                  title: `${props.rowData.candidateId}: ${props.rowData.error}`,
                  "data-test": `failed-delete-${props.rowData.candidateId}`,
                }),
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
}

export function DeleteCandidatesModalFooter({
  failedDeletes,
  disabled,
  onSend,
  onClose,
}: {
  failedDeletes: IDeleteCandidateError[];
  disabled: boolean;
  onSend: () => void;
  onClose: () => void;
}) {
  return failedDeletes.length > 0 ? (
    <Button
      data-test="delete-candidates-close-failed"
      variant="contained"
      color="secondary"
      onClick={onClose}
    >
      Close
    </Button>
  ) : (
    <Button
      data-test="delete-candidates-submit"
      variant="contained"
      color="error"
      onClick={onSend}
      disabled={disabled}
    >
      Confirm Delete
    </Button>
  );
}
